import { render, staticRenderFns } from "./information-personal.vue?vue&type=template&id=40da1b40&scoped=true&"
import script from "./information-personal.vue?vue&type=script&lang=js&"
export * from "./information-personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da1b40",
  null
  
)

export default component.exports